import { render } from "./FrmPredefinidosList.vue?vue&type=template&id=19984214&scoped=true"
import script from "./FrmPredefinidosList.vue?vue&type=script&lang=js"
export * from "./FrmPredefinidosList.vue?vue&type=script&lang=js"

import "./FrmPredefinidosList.vue?vue&type=style&index=0&id=19984214&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19984214"]])

export default __exports__